// Info: Import Local Dependancies
import ChatbotMessage from '../ChatbotMessage/ChatbotMessage';
import '../../assets/css/style.css';

interface IChatbotErrorProps {
  message: string;
}

const ChatbotError = ({ message }: IChatbotErrorProps) => {
  return (
    <div className="react-chatbot-kit-error">
      {/* <h1 className="react-chatbot-kit-error-header">
      
      </h1> */}
      <div className="react-chatbot-kit-error-container">
        {/* <ChatbotMessage
          message={message}
          withAvatar
          loading={false}
          id={1}
          customStyles={{ backgroundColor: '' }}
          messages={[]}
        /> */}
        <div className='chat-bot__error-msg'>{message}</div>
      </div>
      {/* <a
        href=""
        rel="noopener norefferer"
        target="_blank"
        className="react-chatbot-kit-error-docs"
      >
        View the docs
      </a> */}
    </div>
  );
};

export default ChatbotError;
